

module.exports = __webpack_require__.stylable.create(
    "title841348506",
    {"classes":{"root":"title841348506__root"},"vars":{},"stVars":{"black":"#000"},"keyframes":{}},
    "",
    1,
    /*! ../node_modules/@wix/search-box-v2/dist/src/components/Title/Title.st.css */ 1323,
    null
);
